import { useOrders } from '@src/providers';
import { isOrderComplete, useObservable } from '@talos/kyoko';
import { map, shareReplay } from 'rxjs/operators';

/**
 * Shared data source for Open Orders blotters (desktop + mobile).
 * Derives active orders from the provider's combined order stream.
 */
export const useOpenOrdersBlotterObs = () => {
  const { recentOrders, recentOrdersError } = useOrders();

  const dataObservable = useObservable(
    () =>
      recentOrders.pipe(
        // Build the active-order set fresh on every emission. The provider's Map
        // is authoritative (it now evicts stale open entries on OPEN_ORDERS reconnect),
        // so anything not present in the incoming array should not appear here either.
        map(orders => ({
          data: orders.filter(order => !isOrderComplete(order.OrdStatus)),
          initial: true,
          type: 'Order',
        })),
        shareReplay({
          bufferSize: 1,
          refCount: true,
        })
      ),
    [recentOrders]
  );

  return {
    dataObservable,
    errorObservable: recentOrdersError,
  };
};
